fragment flexiblePostsFeaturedByTags on flexibleSections_postsFeaturedByTags_BlockType {
    __typename
    title: plaintext
    description: richTextMinimal
    tags {
        id
    }
}
